import React from "react";

const Boutique = () => {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      {/* Light textured stone background */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://images.pexels.com/photos/7670680/pexels-photo-7670680.jpeg')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#FBF8F1]/70 via-[#FBF8F1]/35 to-transparent" />

      <div className="relative max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-10">
        <div className="hidden md:block" />
        <div className="text-center md:text-left">
          <p className="font-script text-5xl md:text-7xl leading-none gold-gradient-text">
            Shop Our
          </p>
          <p className="font-script text-5xl md:text-7xl leading-none gold-gradient-text mt-2">
            Boutique<span className="text-[#8D7448]">!</span>
          </p>
          <div className="flex items-center justify-center md:justify-start gap-3 my-7">
            <span className="h-px w-12 bg-gradient-to-r from-transparent to-[#B79A68]" />
            <span className="text-[#7D6A42] text-[11px] uppercase tracking-[0.4em] font-cinzel">
              Curated For You
            </span>
          </div>
          <a
            href="#shop"
            className="inline-block bg-[#FBF8F1] hover:bg-[#F7F2E8] text-[#20322E] px-10 py-3 uppercase text-xs tracking-[0.3em] font-semibold font-cinzel transition-all border border-[#B79A68]/40"
          >
            Shop Now
          </a>
        </div>
      </div>
    </section>
  );
};

export default Boutique;
